module.exports = __webpack_public_path__ + "img/PSMIS_POSTER.09cf7694.png";